import { Button, Flex, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <Flex direction="column" align="center" gap={5}>
      <Heading color="red.600" fontWeight="bold" size="4xl">
        403
      </Heading>
      <Heading color="red.600" fontWeight="bold" size="2xl">
        You are not authorized to access this page
      </Heading>
      <Button variant="primary" onClick={() => navigate("/")}>
        Return Home
      </Button>
    </Flex>
  );
};
